<template lang="html">
  <main>
    <PageHeader page-title="Your Bookings" />
    <Header title="Your booking history" level="h4"></Header>
    <section class="accordions">
    <template v-for="(booking, index) in bookings">
      <div class="accordion">
        <div class="accordion__visible">
          <div class="accordion__title large p">
            <p>
              Booking
              <span class="font-bold">
                {{booking.checkInDate | dateToDayMonthYear}} - {{booking.checkOutDate | dateToDayMonthYear}}
              </span>
            </p>
          </div>
          <router-link :to="{name: 'bookingHistory.detail', params: { bookingId: booking.externalId }}" class="button background--transparent color--dark accordion__trigger button--icon-only">
<!--          <router-link :to="`/settings/booking-history/${booking.externalId}`" class="button background&#45;&#45;transparent color&#45;&#45;dark accordion__trigger button&#45;&#45;icon-only">-->
            <svg viewBox="0 0 9 16" class="button__icon button__icon--left"><path fill-rule="nonzero" d="M.22.22a.75.75 0 01.976-.073L1.28.22l7 7a.75.75 0 01.073.976l-.073.084-7 7a.75.75 0 01-1.133-.976l.073-.084 6.469-6.47-6.47-6.47A.75.75 0 01.148.304L.22.22z"></path></svg>
            <div class="button__content">
              <span class="button__text">
              </span>
            </div>
          </router-link>
        </div>
      </div>
    </template>
    </section>
    <PageFooter />
  </main>
</template>

<script>
import BookingContent from '@/dummy/booking-history.json'
import PageFooter from '@/components/page-footer/PageFooter.vue'
import Header from '@/components/heading/Heading'
import PageHeader from '@/sections/page-header/PageHeader'
import Button from '@/components/partials/Button'
import { EVENTS, EventBus } from '@/services/events/EventBus'
import HttpUnAuthenticatedError from '@/objects/Exceptions/HttpUnAuthenticatedError'

import ContentGenerator from '@/sections/content-generator/ContentGenerator.vue'

import MeService from '@/services/MeService'
import HttpError from '@/objects/Exceptions/HttpError'

export default {
  name: 'Settings',
  components: {
    ContentGenerator,
    PageHeader,
    PageFooter,
    Header
  },
  data() {
    return {
      data: BookingContent,
    }
  },
  computed: {
    bookings () {
      console.log('this.$store.state.reservations.reservations: ', this.$store.state.reservations.reservations)
      return this.$store.state.reservations.reservations
    }
  },
  methods: {
    fetchBookings () {
      this.$store.dispatch('reservations/getReservations')
    },
    getBookings() {
      MeService.getAllBookings()
        .then((response) => {
          console.log('response', response)
          if (response.status == 'failed') {
            throw HttpError.parseError(response.message)
          } else {
            for (var i = 0; i < response.reservation.length; i++) {
            this.bookings.fields.linkGroup[0].links.push({
              "title": "Booking "+response.reservation[i].status+" <span class='font-bold'>"+response.reservation[i].checkInDate+" - "+response.reservation[i].checkOutDate+"</span>",
              "link": "/settings/booking-history/" + response.reservation[i].externalId,
            })
          }
          this.data.sections.push(this.bookings)
        }

        }).catch((error) => {
          throw HttpError.parseError(error)
      })
    }
  },
  mounted () {
    // this.getBookings()
    this.fetchBookings()
  }
}
</script>
